import { IPublishOption } from '../../../../redux/reducers';
import { IPublishOptionSchema } from '../internalTypes';
import { getOptionId } from './getOptionId';

export function mapPeriod(period: IPublishOptionSchema): IPublishOption {
  const periodId = getOptionId(period);

  return {
    ...period,
    id: periodId,
    price: parseFloat(period.price),
    marketingPrice: parseFloat(period.marketingPrice),
  };
}
